import { render, staticRenderFns } from "./ellipsis-text.vue?vue&type=template&id=62d0dd77"
import script from "./ellipsis-text.vue?vue&type=script&lang=js"
export * from "./ellipsis-text.vue?vue&type=script&lang=js"
import style0 from "./ellipsis-text.vue?vue&type=style&index=0&id=62d0dd77&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports